export default __webpack_public_path__ + "static/media/12.cea68775.wav";